import { Component, EventEmitter, Input, Output } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { CompanyService } from '../../company/company.service';

interface Faq {
  question: string;
  answer: string;
  isOpen: boolean;
}

@Component({
    selector: 'app-faq-panel',
    templateUrl: './faq-panel.component.html',
    styleUrls: ['./faq-panel.component.scss'],
    standalone: false
})
export class FaqPanelComponent {
  @Input() isOpen = false;
  @Input() currentPage: string;
  @Output() closePanel = new EventEmitter<void>();
  
  isLoadingFaq = false;
  faqList: Faq[] = [];

  constructor(private companyService: CompanyService) {}
  
  ngOnChanges() {
    if (this.isOpen) {
      this.loadFaqs();
    }
  }
  
  close(event: Event) {
    event.preventDefault();
    this.closePanel.emit();
  }
  
  private loadFaqs(): void {
    this.isLoadingFaq = true;
    
    this.companyService.getFAQs(this.currentPage, this.companyService.groupCode)
      .pipe(finalize(() => this.isLoadingFaq = false))
      .subscribe({
        next: (resp) => {
          if (resp["message"] === "Success") {
            this.faqList = resp["data"]["faqs"];
          } else {
            this.faqList = [];
          }
        },
        error: () => {
          this.faqList = [];
        }
      });
  }
}